import {
    Component,
    OnInit,
    ViewContainerRef,
    ViewChild,
    TemplateRef,
} from '@angular/core';
import { SiteServices } from '../../services/siteservices';

import { Router, Event as NavigationEvent } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { Location } from '@angular/common';

import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

import { ProviderContext } from '../../data/Entities';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalDialogService } from 'ngx-modal-dialog';
import { SimpleModalComponent } from 'ngx-modal-dialog';

declare var appConfig: any;

@Component({
    selector: 'discountfrm',
    templateUrl: 'templates/get/Discount/discount_detail',
})
export class DiscountDetailFrm implements OnInit {
    PCODE: string = 'DISCOUNT';
    providersDtx: ProviderContext;
    
    public submitted: boolean = false;

    public errstr: string;

    public entity: any = {
        MaxUse: 1,
        TargetPlatforms: null,
        TargetPlatformsArray: [] };

    public modalRef: BsModalRef;
    provList: [];


    allTargetPlatform: string[] =
        [
            // ROKSH
            'ROKSH_DESKTOP_HUN',
            'ROKSH_DESKTOP_AUT',
            'ROKSH_MOBILE_HUN',
            'ROKSH_MOBILE_AUT',

            // ALDI
            'ALDI_HUN',
            'ALDI_CHE',

            // MOL
            'MOL_MOBILE_HUN'];

    constructor(
        public siteServices: SiteServices,
        private route: ActivatedRoute,
        private router: Router,
        private modalService: BsModalService,
        public modalService2: ModalDialogService,
        public location: Location,
        public viewRef: ViewContainerRef
    ) {
        this.providersDtx = new ProviderContext({ ProviderCode: 'PROVIDER', SortField: 'ProviderName' });
        this.providersDtx.addFilter('Available', 'true');
        
        this.siteServices.provider_GetAll(
            this.providersDtx,
            (data) => {
                this.provList = data.TagObject;
            }
        );
    }

    clearTargetPlatforms(entity: any) {
        entity.TargetPlatformsArray = [];
    }

    refresh(id: any) {
        if (id && id != '0') {
            this.siteServices.provider_GetDataByID(
                this.PCODE,
                id,
                null,
                (data) => {
                    this.entity = {
                        ...data.TagObject,
                        TargetPlatformsArray: data.TagObject.TargetPlatforms
                            ? data.TagObject.TargetPlatforms.split(',').map(x => x.trim())
                            : []
                    };
                }
            );
        }
    }

    ngOnInit() {
        this.route.params.subscribe((params) => {
            if (params.id) {
                let id = params.id;
                if (id && id != '0') {
                    this.refresh(id);
                }
            }
        });
    }

    save(frm) {
        this.submitted = true;
        if (!frm.valid) {
            this.siteServices.error('Hibás kitöltés!');
            return;
        }

        const targetPlatforms = this.entity.TargetPlatformsArray;

        this.entity.TargetPlatforms =
            targetPlatforms && targetPlatforms.length > 0
                ? targetPlatforms.join(',')
                : null;

        this.sure(this.viewRef, (x) => {
            this.siteServices.provider_Save(this.PCODE, this.entity, (data) => {
                this.entity = data.TagObject;

                this.siteServices.onChangeDetail.next(this.entity);

                setTimeout((x) => {
                    this.siteServices.success('OK');
                    this.location.back();
                }, 200);
            });
        });
    }

    public sure(viewRef: ViewContainerRef, clbFunc: Function) {
        const actionButtons = [
            {
                text: 'igen',
                onAction: () => {
                    clbFunc();
                    return true;
                },
            },
            {
                text: 'nem',
                onAction: () => {
                    return true;
                },
            },
        ];

        this.modalService2.openDialog(viewRef, {
            title: 'Biztos vagy benne?',
            childComponent: SimpleModalComponent,
            actionButtons: actionButtons,
            data: { text: '' },
        });
    }
}
